export const geShopIconConvertor: Record<string, string> = {
  Dokan: 'icon-dokan',
  Laboratory: 'icon-Group-1',
  Car: 'icon-tractor',
  Land: 'icon-nasagh',
  Worker: 'icon-boneh-store',
  Lab: 'icon-Group-1',
};
